import { render, staticRenderFns } from "./ImportDataView.vue?vue&type=template&id=63d6a9de"
import script from "./ImportDataView.vue?vue&type=script&lang=js"
export * from "./ImportDataView.vue?vue&type=script&lang=js"
import style0 from "./ImportDataView.vue?vue&type=style&index=0&id=63d6a9de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports